import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router } from '@angular/router';
import { AppIdleService, AppService, AppInstanceService, SessionManagerService, AppIdleComponent, LayoutComponent, AnalyticsService } from 'smartauction-frontend-micro-library';
import { environment } from 'src/environments/environment';
import { NgxSpinnerModule } from 'ngx-spinner';
import { Store } from '@ngxs/store';
import { SetCpCode } from 'remarketing-angular-library';
import { skipWhile, takeUntil, timer } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [LayoutComponent, NgxSpinnerModule]
})
export class AppComponent extends AppIdleComponent implements OnInit, OnDestroy {
  title = 'SmartAuction';
  environment = environment;

  constructor(
    router: Router,
    idleService: AppIdleService,
    session: SessionManagerService,
    modalService: BsModalService,
    appService: AppService,
    appInstance: AppInstanceService,
    private readonly analyticsService: AnalyticsService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly store: Store
  ) {
    super( idleService, session, modalService, appInstance, router );
    appService.initializeOlympus(environment);
    this.consumeCpCode();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  consumeCpCode(){
    this.activatedRoute.queryParams.pipe(
      skipWhile(params => !params),
      takeUntil(timer(60000))
    ).subscribe(params => {
      if (params.cp) {
        this.analyticsService.digitalData.user.cpCode = params.cp;
        this.store.dispatch(new SetCpCode(params.cp));
      }
    });
  }
}
